function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDgaLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "29px",
    viewBox: "0 0 20 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 15.34,
    y1: 28.040001,
    x2: 15.34,
    y2: 4.23,
    gradientTransform: "matrix(0.952835,0,0,-0.93593,-0.000000000000001692,30.144063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,67.058824%,68.627451%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "rgb(0%,57.647059%,70.588235%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(0%,50.196078%,72.941176%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(46.666667%,28.235294%,58.823529%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 11.91,
    y1: 28.040001,
    x2: 11.91,
    y2: 4.23,
    gradientTransform: "matrix(0.952835,0,0,-0.93593,-0.000000000000001692,30.144063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,67.058824%,68.627451%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "rgb(0%,57.647059%,70.588235%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(0%,50.196078%,72.941176%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(46.666667%,28.235294%,58.823529%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 16.379999,
    y1: 28.040001,
    x2: 16.379999,
    y2: 4.23,
    gradientTransform: "matrix(0.952835,0,0,-0.93593,-0.000000000000001692,30.144063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,67.058824%,68.627451%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "rgb(0%,57.647059%,70.588235%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(0%,50.196078%,72.941176%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(46.666667%,28.235294%,58.823529%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 10.49,
    y1: 28.040001,
    x2: 10.49,
    y2: 4.23,
    gradientTransform: "matrix(0.952835,0,0,-0.93593,-0.000000000000001692,30.144063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(16.078431%,69.803922%,69.803922%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "rgb(6.27451%,56.862745%,70.196078%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(0.392157%,49.411765%,70.980392%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(43.921569%,29.411765%,59.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 4.61,
    y1: 28.040001,
    x2: 4.61,
    y2: 4.23,
    gradientTransform: "matrix(0.952835,0,0,-0.93593,-0.000000000000001692,30.144063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,67.058824%,68.627451%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "rgb(0%,57.647059%,70.588235%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(0%,50.196078%,72.941176%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(46.666667%,28.235294%,58.823529%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 9.08,
    y1: 28.040001,
    x2: 9.08,
    y2: 4.23,
    gradientTransform: "matrix(0.952835,0,0,-0.93593,-0.000000000000001692,30.144063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,67.058824%,68.627451%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "rgb(0%,57.647059%,70.588235%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(0%,50.196078%,72.941176%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(46.666667%,28.235294%,58.823529%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 5.63,
    y1: 28.040001,
    x2: 5.63,
    y2: 4.23,
    gradientTransform: "matrix(0.952835,0,0,-0.93593,-0.000000000000001692,30.144063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,67.058824%,68.627451%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "rgb(0%,57.647059%,70.588235%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(0%,50.196078%,72.941176%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(46.666667%,28.235294%,58.823529%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 10.816406 14.234375 C 10.667969 14.34375 10.582031 14.511719 10.578125 14.691406 L 10.578125 19.371094 C 10.578125 19.6875 10.835938 19.941406 11.15625 19.941406 C 11.480469 19.941406 11.738281 19.6875 11.738281 19.371094 L 11.738281 15 L 16.816406 11.507812 C 16.996094 11.601562 17.195312 11.648438 17.398438 11.640625 C 17.910156 11.640625 18.367188 11.339844 18.5625 10.875 C 18.753906 10.414062 18.644531 9.882812 18.285156 9.527344 C 17.921875 9.175781 17.378906 9.074219 16.910156 9.265625 C 16.441406 9.460938 16.136719 9.914062 16.140625 10.414062 Z M 10.816406 14.234375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 7.222656 13.007812 L 7.222656 17.6875 C 6.714844 17.949219 6.453125 18.519531 6.59375 19.066406 C 6.730469 19.613281 7.230469 19.996094 7.804688 19.996094 C 8.378906 19.996094 8.878906 19.613281 9.015625 19.066406 C 9.152344 18.519531 8.894531 17.949219 8.386719 17.6875 L 8.386719 13.296875 L 15.902344 8.148438 C 16.050781 8.039062 16.140625 7.867188 16.140625 7.683594 L 16.140625 4.191406 C 16.140625 3.875 15.878906 3.621094 15.558594 3.621094 C 15.238281 3.621094 14.980469 3.875 14.980469 4.191406 L 14.980469 7.382812 L 7.460938 12.539062 C 7.296875 12.636719 7.203125 12.820312 7.222656 13.007812 Z M 7.222656 13.007812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 16.199219 14.570312 L 14.292969 15.890625 C 14.164062 15.976562 14.074219 16.109375 14.050781 16.257812 C 14.023438 16.410156 14.0625 16.5625 14.160156 16.683594 C 14.265625 16.835938 14.441406 16.921875 14.625 16.917969 C 14.746094 16.925781 14.863281 16.890625 14.960938 16.816406 L 16.863281 15.496094 C 17.128906 15.316406 17.191406 14.960938 17.007812 14.703125 C 16.824219 14.441406 16.460938 14.378906 16.199219 14.5625 Z M 16.199219 14.570312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 19.886719 17.894531 C 19.796875 17.765625 19.664062 17.675781 19.507812 17.648438 C 19.355469 17.621094 19.195312 17.652344 19.066406 17.742188 L 9.996094 23.976562 L 0.953125 17.742188 C 0.824219 17.652344 0.664062 17.617188 0.507812 17.648438 C 0.351562 17.675781 0.210938 17.765625 0.125 17.894531 C -0.0585938 18.15625 0.0078125 18.515625 0.277344 18.699219 L 8.996094 24.695312 L 6.421875 26.457031 C 6.246094 26.367188 6.050781 26.320312 5.851562 26.324219 C 5.335938 26.324219 4.875 26.628906 4.679688 27.097656 C 4.484375 27.5625 4.59375 28.097656 4.957031 28.453125 C 5.320312 28.808594 5.867188 28.914062 6.34375 28.71875 C 6.816406 28.523438 7.121094 28.066406 7.117188 27.5625 L 10.035156 25.410156 L 12.941406 27.402344 C 12.941406 27.457031 12.941406 27.515625 12.941406 27.5625 C 12.9375 28.066406 13.242188 28.523438 13.714844 28.71875 C 14.1875 28.914062 14.734375 28.808594 15.097656 28.453125 C 15.464844 28.097656 15.574219 27.5625 15.378906 27.097656 C 15.183594 26.628906 14.71875 26.324219 14.207031 26.324219 C 14.003906 26.324219 13.804688 26.367188 13.625 26.457031 L 11.054688 24.695312 L 19.761719 18.699219 C 20.015625 18.503906 20.070312 18.152344 19.886719 17.894531 Z M 19.886719 17.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 3.8125 4.378906 L 5.71875 3.050781 C 5.84375 2.964844 5.929688 2.832031 5.953125 2.683594 C 5.980469 2.535156 5.941406 2.382812 5.851562 2.261719 C 5.726562 2.117188 5.535156 2.042969 5.34375 2.066406 C 5.226562 2.0625 5.109375 2.101562 5.011719 2.167969 L 3.105469 3.5 C 2.980469 3.585938 2.894531 3.71875 2.867188 3.867188 C 2.84375 4.019531 2.878906 4.171875 2.972656 4.292969 C 3.070312 4.417969 3.214844 4.496094 3.375 4.511719 C 3.53125 4.527344 3.691406 4.480469 3.8125 4.378906 Z M 3.8125 4.378906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 11.613281 2.507812 L 11.613281 5.652344 L 4.097656 10.808594 C 3.941406 10.914062 3.847656 11.089844 3.847656 11.277344 L 3.847656 14.765625 C 3.847656 15.082031 4.109375 15.335938 4.429688 15.335938 C 4.75 15.335938 5.011719 15.082031 5.011719 14.765625 L 5.011719 11.574219 L 12.53125 6.417969 C 12.683594 6.308594 12.773438 6.136719 12.777344 5.949219 L 12.777344 2.507812 C 13.1875 2.296875 13.445312 1.882812 13.445312 1.429688 C 13.484375 0.964844 13.257812 0.515625 12.851562 0.269531 C 12.445312 0.0273438 11.9375 0.0273438 11.53125 0.269531 C 11.125 0.515625 10.898438 0.964844 10.9375 1.429688 C 10.957031 1.878906 11.210938 2.289062 11.613281 2.507812 Z M 11.613281 2.507812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 2.582031 9.742188 C 3.269531 9.730469 3.816406 9.179688 3.8125 8.503906 L 9.148438 4.695312 C 9.296875 4.585938 9.382812 4.410156 9.386719 4.226562 L 9.386719 0.773438 C 9.386719 0.460938 9.125 0.203125 8.804688 0.203125 C 8.484375 0.203125 8.222656 0.460938 8.222656 0.773438 L 8.222656 3.9375 L 3.164062 7.417969 C 2.984375 7.328125 2.785156 7.28125 2.582031 7.289062 C 1.894531 7.289062 1.332031 7.835938 1.332031 8.515625 C 1.332031 9.191406 1.894531 9.742188 2.582031 9.742188 Z M 2.582031 9.742188 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDgaLogoIcon);
export default __webpack_public_path__ + "static/media/DGA-logo-icon.0434d9df2733a583e230b7531caf1302.svg";
export { ForwardRef as ReactComponent };